module.exports = __webpack_public_path__ + "static/media/Dinar Rahimita.1b92f0b3.png";